import React, { useEffect, useRef, useState } from "react";
import "../../assets/css/HoliLoader.css";
import $ from "jquery";

function HoliLoader() {
  const canvasRef = useRef(null);
  const [text, setText] = useState("");

  useEffect(() => {
    const messages = [
      "Happy Holi ",
      "Festival of Colors",
      "Splash Joy & Happiness",
      "Celebrate with Colors",
      "Rang Barse Holi Hai!",
    ];
    const msg = messages[Math.floor(Math.random() * messages.length)];
    let i = 0;

    $("body").css("overflow", "hidden");

    const typing = setInterval(() => {
      if (i < msg.length) setText((p) => p + msg[i++]);
      else clearInterval(typing);
    }, 90);

    setTimeout(() => {
      $("#holi-loading").fadeOut(800);
      $("body").css("overflowY", "visible");
      $("#root").fadeIn();
    }, 5500);

    return () => clearInterval(typing);
  }, []);

  /* ================= CANVAS COLOR BURST ================= */
  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");
    canvas.width = window.innerWidth;
    canvas.height = window.innerHeight;

    let particles = [];
    const colors = [
      "#FF1A1A",
      "#FFDD00",
      "#00FF66",
      "#FF33CC",
      "#66CCFF",
      "#FF6600",
      "#FF0066",
    ];

    class Particle {
      constructor() {
        this.x = Math.random() * canvas.width;
        this.y = -20;
        this.radius = Math.random() * 12 + 8;
        this.color = colors[Math.floor(Math.random() * colors.length)];
        this.vx = Math.random() * 4 - 2;
        this.vy = Math.random() * 5 + 3;
        this.gravity = 0.1;
        this.life = 100;
      }

      update() {
        this.vy += this.gravity;
        this.x += this.vx;
        this.y += this.vy;
        this.life--;
      }

      draw() {
        ctx.beginPath();
        ctx.arc(this.x, this.y, this.radius, 0, Math.PI * 2);
        ctx.fillStyle = this.color;
        ctx.fill();
      }
    }

    function animate() {
      ctx.fillStyle = "rgba(255, 255, 255, 0.2)";
      ctx.fillRect(0, 0, canvas.width, canvas.height);

      if (Math.random() < 0.15) particles.push(new Particle());

      particles.forEach((p, i) => {
        p.update();
        p.draw();
        if (p.life <= 0) particles.splice(i, 1);
      });

      requestAnimationFrame(animate);
    }

    animate();
  }, []);

  return (
    <div id="holi-loading" className="holi-loader">
      <canvas ref={canvasRef} className="holi-canvas"></canvas>

      <h1 className="holi-text">{text}</h1>
      <p className="holi-tagline">Splash happiness & colors!</p>
    </div>
  );
}

export default HoliLoader;
